import { localForage } from '@/lib/local-forage';

export const getRawRedirectParameters = () => {
  return {
    redirect_uri: window.OIDC_REDIRECT_URL,
    client_id: window.OIDC_CLIENT_ID,
    ...(typeof window.OIDC_PARAMETERS === 'string'
      ? JSON.parse(window.OIDC_PARAMETERS)
      : window.OIDC_PARAMETERS)
  };
};

export function signin({ redirectUri }: { redirectUri?: string }): void {
  const baseParams = getRawRedirectParameters();
  const params = new URLSearchParams({
    ...baseParams,
    ...(redirectUri ? { state: btoa(redirectUri) } : {})
  }).toString();

  window.location.href = `${window.OIDC_BASE_URL}${window.OIDC_AUTH_ENDPOINT}?${params}`;
}

export async function getToken(): Promise<string> {
  const token = await localForage.getItem<string | null | undefined>('token');
  return token ?? '';
}

export function getTokenSync(): string {
  return localStorage.getItem('whitelabel/token') ?? '';
}

export function setToken(token: string): Promise<string> {
  return localForage.setItem<string>('token', token);
}

export function setIdToken(token: string): Promise<string> {
  return localForage.setItem<string>('id_token', token);
}

export async function getIdToken(): Promise<string> {
  const token = await localForage.getItem<string | null | undefined>('id_token');
  return token || '';
}

export async function removeToken(): Promise<void> {
  await localForage.removeItem('id_token');
  return localForage.removeItem('token');
}

// TODO - tech debt, should be configurable
export async function signout(token: string): Promise<void> {
  const meta = new URLSearchParams({
    post_logout_redirect_uri: window.OIDC_REDIRECT_URL,
    id_token_hint: token
  }).toString();

  window.location.replace(`${window.OIDC_BASE_URL}${window.OIDC_END_SESSION_ENDPOINT}?${meta}`);
}
